export const OPEN_DEVICES_DRAWER = 'OPEN_DEVICES_DRAWER';
export const CLOSE_DEVICES_DRAWER = 'CLOSE_DEVICES_DRAWER';

const open = employeeId => ({
  type: OPEN_DEVICES_DRAWER,
  payload: employeeId,
});

const close = () => ({
  type: CLOSE_DEVICES_DRAWER,
});

export default { open, close };
